import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * AuraIcon — das Symbol für Aura, app-weit an einer Stelle festgelegt.
 *
 * Vorher standen für dieselbe Sache fünf verschiedene Zeichen nebeneinander:
 * `Sparkles` im Header, `Zap` in der Logbuch-Kachel, `Award` im Abschluss-Screen,
 * `Star` auf der Profilkarte und ein PNG (`/assets/aura-symbol.png`) in Logbuch-Karte
 * und Chat. Wer 617 Aura im Header sah und danach „+48 Aura erhalten" mit einem
 * Orden daneben, musste erst prüfen, ob das überhaupt dieselbe Währung ist.
 *
 * Warum `Sparkles`:
 * - Es steht im Header und damit auf jedem Bildschirm — der stärkste Wiedererkennungsanker.
 * - Als Vektor färbt es sich mit allen vier Themes mit und bleibt bei 16px scharf.
 *   Das PNG hat den Otter mit weiss-orangem Schein fest eingebacken, dreht also
 *   im Dunkel- und Kontrast-Modus nicht mit.
 * - `Star` und `Award` sind bereits belegt: Sterne sind die Bewertung im
 *   Session-Feedback, Orden/Pokale stehen im Leaderboard für den Rang.
 *
 * NICHT betroffen: die Landingpage, die als Werbewelt eigene Regeln hat (dort
 * und im Chat steckt das PNG noch). Die Fokus-Aura (`focus/FocusAura.js`) nutzt
 * das PNG seit Sep 2026 nicht mehr — sie malt den Otter als Canvas-Szene.
 *
 * Verwendung — überall dort, wo ein Aura-WERT steht:
 *   <AuraIcon className="h-4 w-4 text-primary" />
 *   <StatTile icon={AuraIcon} value={aura} label="Aura verdient" accent="aura" />
 *   <Badge icon={AuraIcon}>+{aura}</Badge>
 */
const AuraIcon = React.forwardRef((props, ref) => <Sparkles ref={ref} {...props} />);

AuraIcon.displayName = 'AuraIcon';

export default AuraIcon;
